import React, { useState, useEffect } from "react";
import Header from "../Components/Head";
import Table from "react-bootstrap/Table";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Moment from "react-moment";
import toast, { Toaster } from "react-hot-toast";

function Userdata() {
  const [data, setdata] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [listPerPage] = useState(10);
  const pagesVisited = pageNumber * listPerPage;
  const lists = data.slice(pagesVisited, pagesVisited + listPerPage);
  const pageCount = Math.ceil(data.length / listPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const usersdata = () => {
    axios
      .get("https://api.digitalraiz.co.in/api/user/leads/data")
      .then((res) => {
        console.log(res.data);
        setdata(res.data.data);
      });
  };

  useEffect(() => {
    usersdata();
  }, []);

  const manageDelete = (data) => {
    const confirmBox = window.confirm("Do you really want to Delete?");
    if (confirmBox === true) {
      deleteUser(data);
    }
  };

  const deleteUser = (data) => {
    var token = sessionStorage.getItem("token" || "");
    const data1 = data._id;
    console.log(data1);
    axios
      .delete(
        "https://api.digitalraiz.co.in/api/admin/searchfilter/removeabledata" +
          "/" +
          data1,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        (res) => {
          if (res.status === 200) {
            toast.success(res.data.message);
            usersdata();
          }
        },
        (error) => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message);
          }
        }
      );
  };

  return (
    <div>
      <Header />

      <div className="container-flied">
        <div style={{ paddingTop: "120px" }}>
          <div className="card contact-form-block">
            <div>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Sl.No</th>
                    <th>DATE</th>
                    <th>FULL NAME</th>
                    <th>MOBILE</th>
                    <th>EMAIL ID</th>
                    <th>SERVICES</th>
                    <th>LOCATION</th>
                    <th>PROJECT NAME</th>
                    <th>PLANNING</th>
                    <th>PROJECT DESCRIPTION</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {lists.map((data, x) => {
                    return (
                      <tr key={x}>
                        <td>{(pageNumber - 1) * 10 + x + 11}</td>
                        <td>
                          <Moment format="DD/MM/YYYY hh:mm A">
                            {data.updatedAt}
                          </Moment>
                        </td>
                        <td>{data.name}</td>
                        <td>{data.phone}</td>
                        <td>{data.email}</td>
                        <td>{data.service}</td>
                        <td>{data.location}</td>
                        <td>{data.projectname}</td>
                        <td>{data.lookingfor}</td>
                        <td>{data.aboutproject}</td>
                        <td>
                          <button
                            className="btn btn-outline-danger bg-danger"
                            onClick={() => {
                              manageDelete(data);
                            }}
                          >
                            <i class="fa fa-trash-o text-white" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <div className="mt-3" style={{ float: "right" }}>
                {/* <Stack spacing={2}> */}
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  pageCount={pageCount}
                  onPageChange={changePage}
                  containerClassName={"pagination"}
                  previousLinkClassName={"previousBttn"}
                  nextLinkClassName={"nextBttn"}
                  disabledClassName={"disabled"}
                  activeClassName={"active"}
                  total={lists.length}
                />
                {/* </Stack> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
}

export default Userdata;
